import React from 'react'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'

import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'
import PortalLinkImageFormContainer from './PortalLinkImageFormContainer';
import { updateLinkImage } from '../../../actions/portal';

class PortalLinkImageFormModalWithRedux extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
  }

  handleClose(params) {
    if (params) {
      console.log("params", params)
      this.props.actions.updateLinkImage(params)
    }
    this.props.modalActions.hideModal()
  }

  render() {
    return (
      <PortalLinkImageFormContainer
        onRequestClose={this.handleClose}
        params={this.props.modal.openParams}
      />
    )
  }
}

PortalLinkImageFormModalWithRedux.propTypes = {
  ...modalPropTypes,
}

export default compose(
  withReduxModal,
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(
        { updateLinkImage: updateLinkImage },
        dispatch,
      ),
    }),
  ),
)(PortalLinkImageFormModalWithRedux)



// WEBPACK FOOTER //
// ./src/components/templates/portal-link/PortalLinkImageFormModalWithRedux.js